import React from 'react'
import LinearProgress from '@mui/material/LinearProgress'
import { Box } from '@mui/material'

export const LinearProgressLoader = () => (
  <Box sx={{ width: '100%' }}>
    <LinearProgress color="secondary" />
  </Box>
)
